import React, { Fragment } from 'react';
import classNames from 'classnames';
import { path, pathOr } from 'ramda';

import { FormattedMessage, FormattedDate, injectIntl } from '../../util/reactIntl';
import { DATE_TYPE_DATE, propTypes } from '../../util/types';
import {
  utcTimeZone,
  getMorningOrAfternoonByDate,
  moment,
  getHourFormattedBookingDate,
} from '../../util/dates';
import css from './BookingBreakdown.css';

const BookingPeriod = props => {
  const { startDate, dateType, isBookingFullDay, intl } = props;
  const dateWithTz = moment(startDate);

  const timeFormatOptions =
    dateType === DATE_TYPE_DATE
      ? {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
      }
      : {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
      };

  const dayTimeMessage = isBookingFullDay
    ? intl.formatMessage({ id: 'BookingBreakdown.fullday' })
    : getMorningOrAfternoonByDate(dateWithTz, intl);

  return (
    <div className={css.bookingPeriod}>
      <div className={css.bookingPeriodSection}>
        <div className={css.dayLabel}>
          <FormattedMessage id='BookingBreakdown.date' />
        </div>
        <div className={css.dayInfo}>
          <FormattedDate value={startDate} {...timeFormatOptions} />
        </div>
        <div className={css.itemLabel}>
          <span>{dayTimeMessage}</span>
        </div>
      </div>
    </div>
  );
};

const BookingDateWithTimes = props => {
  const { startDate, endDate, dateType, intl } = props;
  const timeFormatOptions =
    dateType === DATE_TYPE_DATE
      ? {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
        timeZone: utcTimeZone,
      }
      : {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
        timeZone: utcTimeZone,
      };

  return (
    <div className={css.bookingPeriod}>
      <div className={css.bookingPeriodSection}>
        <div className={css.dayLabel}>
          <div className={css.dayInfo}>
            <FormattedMessage id='BookingBreakdown.date' />
          </div>
          <div>
            <FormattedDate value={startDate} {...timeFormatOptions} />
          </div>
        </div>
        <div className={css.dateTimes}>
          <div className={css.dateTimeItemContainer}>
            <div className={css.dateTimeItem}>
              <FormattedMessage id='BookingBreakdown.start' />
            </div>
            <span>{getHourFormattedBookingDate(startDate, intl)}</span>
          </div>
          <div className={classNames(css.dateTimeItemContainer, css.rightItem)}>
            <div className={css.dateTimeItem}>
              <FormattedMessage id='BookingBreakdown.end' />
            </div>
            <span>{getHourFormattedBookingDate(endDate, intl)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const LineItemBookingPeriod = props => {
  const { booking, dateType, isBookingFullDay, intl } = props;
  const isEveningMode = pathOr(false, ['attributes', 'isEveningMode'], booking);
  const dateWithTz = moment(path(['attributes', 'start'], booking));
  const displayStart = moment(path(['attributes', 'displayStart'], booking));
  const displayEnd = moment(path(['attributes', 'displayEnd'], booking));

  // Attributes: displayStart and displayEnd can be used to differentiate shown time range
  // from actual start and end times used for availability reservation. It can help in situations
  // where there are preparation time needed between bookings.
  // Read more: https://www.sharetribe.com/api-reference/marketplace.html#bookings
  return (
    <Fragment>
      <div className={css.lineItem}>
        {isEveningMode ? (
          <BookingDateWithTimes
            startDate={displayStart}
            endDate={displayEnd}
            dateType={dateType}
            intl={intl}
          />
        ) : (
          <BookingPeriod
            startDate={dateWithTz}
            dateType={dateType}
            isBookingFullDay={isBookingFullDay}
            intl={intl}
          />
        )}
      </div>
      <hr className={css.totalDivider} />
    </Fragment>
  );
};
LineItemBookingPeriod.defaultProps = { dateType: null };

LineItemBookingPeriod.propTypes = {
  booking: propTypes.booking.isRequired,
  dateType: propTypes.dateType,
};

export default injectIntl(LineItemBookingPeriod);



// WEBPACK FOOTER //
// ./src/components/BookingBreakdown/LineItemBookingPeriod.js